precision mediump float;
varying vec2 vUv;
varying vec3 vNormal;
varying vec4 vPosition;
void main() {
    vUv = uv;
    vPosition = modelViewMatrix * vec4(position, 1.0);
    vNormal = normalize(normalMatrix * normal);
    gl_Position = projectionMatrix * vPosition;
}